(ns minorodata.analytics.events
  (:require
   [re-frame.core :as re-frame]
   ["date-fns" :refer [subDays]]))


(re-frame/reg-event-fx
 :analytics.events/init
 (fn [{:keys [db]}]
   {:db (update-in db [:analytics :timeframe] #(merge {:from (subDays (js/Date.) 7)
                                                       :to   (js/Date.)}
                                                      %))
    :dispatch-n [[:analytics.api/fetch-activity]
                 [:analytics.api/fetch-transforms]
                 [:analytics.api/fetch-sources]
                 [:analytics.api/fetch-extracts]]}))

(re-frame/reg-event-fx
 :analytics.events/refresh
 (fn []
   {:dispatch-n [[:analytics.api/fetch-activity]
                 [:analytics.api/fetch-transforms]
                 [:analytics.api/fetch-sources]
                 [:analytics.api/fetch-extracts]]}))

(re-frame/reg-event-fx
 :analytics.events/set-timeframe
 (fn [{:keys [db]} [_ timeframe]]
   {:db (assoc-in db [:analytics :timeframe] timeframe)
    :dispatch-n [[:analytics.api/fetch-activity]
                 [:analytics.api/fetch-transforms]
                 [:analytics.api/fetch-sources]
                 [:analytics.api/fetch-extracts]]}))

(re-frame/reg-event-fx
 :analytics.events/set-source-visibility
 (fn [{:keys [db]} [_ ids]]
   {:dispatch [:users.api/update-user-preferences
               {:preferences {:analytics {:visible-sources ids}}}]}))
